<template>
  <div>chart view</div>
</template>

<script>
export default {
  name: 'ChartView'
}
</script>
